/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { Flag, Briefcase, HandHeart, Lightbulb, HeartHandshake } from 'lucide-react';

// Tipi di annuncio della Bacheca: icona + colore semantico (token brand per il tipo di default).
export const TYPE_META = {
  initiative: { icon: Flag, color: 'var(--wl-primary)' },
  help: { icon: HandHeart, color: '#B45309' },
  project: { icon: Lightbulb, color: '#7C3AED' },
  job: { icon: Briefcase, color: '#1D4ED8' },
  wellness: { icon: HeartHandshake, color: '#DB2777' },
};

export const BOARD_TYPES = Object.keys(TYPE_META);

export const EMPTY_BOARD_FORM = {
  title: '', description: '', is_paid: false, price: '', location: '',
  start_date: '', end_date: '', category: '', image_base64: null,
  type: 'initiative', contact_info: '', deadline: '',
};

/** Chiave "visiva" di un annuncio: stesso autore + titolo + tipo → stessa card. */
export const boardItemVisualKey = (i) =>
  `${i?.author?.full_name || i?.author_id}|${(i?.title || '').trim().toLowerCase()}|${i?.type || 'initiative'}`;
